var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgAddPictureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 47,
    viewBox: "0 0 51 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5652 11.1905H39.5361L35.4783 6.71429H22.1739V11.1905H33.527L37.5848 15.6667H46.5652V42.5238H11.087V22.381H6.65217V42.5238C6.65217 44.9857 8.64783 47 11.087 47H46.5652C49.0043 47 51 44.9857 51 42.5238V15.6667C51 13.2048 49.0043 11.1905 46.5652 11.1905ZM17.7391 29.0952C17.7391 35.2724 22.7061 40.2857 28.8261 40.2857C34.9461 40.2857 39.913 35.2724 39.913 29.0952C39.913 22.9181 34.9461 17.9048 28.8261 17.9048C22.7061 17.9048 17.7391 22.9181 17.7391 29.0952ZM28.8261 22.381C32.4848 22.381 35.4783 25.4024 35.4783 29.0952C35.4783 32.7881 32.4848 35.8095 28.8261 35.8095C25.1674 35.8095 22.1739 32.7881 22.1739 29.0952C22.1739 25.4024 25.1674 22.381 28.8261 22.381ZM11.087 11.1905H17.7391V6.71429H11.087V0H6.65217V6.71429H0V11.1905H6.65217V17.9048H11.087V11.1905Z",
    fill: "#4A5661"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPictureIcon);
export default __webpack_public_path__ + "static/media/addPictureIcon.549957d3d32d389ec358db8e10f21849.svg";
export { ForwardRef as ReactComponent };